import { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectors,
  actions,
} from '../../store/dux/field-boundary-management-dux';
import { usePrevious } from '../../hooks';

export function useBoundaryChangeStack() {
  const dispatch = useDispatch();
  const current = useSelector(selectors.currentBoundary);
  const index = useSelector(selectors.currentBoundaryIndex);
  const previousIndex = usePrevious(index);
  const canUndo = useSelector(selectors.canUndo);
  const canRedo = useSelector(selectors.canRedo);

  const undo = useCallback(() => {
    dispatch(actions.undo());
  }, [dispatch]);

  const redo = useCallback(() => {
    dispatch(actions.redo());
  }, [dispatch]);

  return useMemo(
    () => ({
      current,
      moveBack: canUndo && undo,
      moveForward: canRedo && redo,
      hasMoved:
        current !== undefined &&
        previousIndex !== undefined &&
        index !== previousIndex,
    }),
    [canRedo, canUndo, current, index, previousIndex, redo, undo],
  );
}
